<ul *ngIf="screenWidth>1024" class="lang-sticky-toolbar list-unstyled" (mouseenter)="hovered=true"
  (mouseleave)="hovered=false">
  <li class="current-language"> {{currentLanguage | uppercase}} </li>
  <ng-container *ngIf="hovered">
    <li *ngFor="let lang of languages" (click)="setCurrentLanguage(lang,true)">
      <ng-container *ngIf="currentLanguage!==lang">
        {{lang | uppercase}}
      </ng-container>
    </li>
  </ng-container>
</ul>

<div class="mobile-language" *ngIf="screenWidth<1025 && isSidebar">
  <p-accordion>
    <p-accordionTab class="mobile-language-acordion">
      <ng-template pTemplate="header">
        <div class="d-flex w-100">
          <span class="fa fa-language fa-3x pt-1"></span>
          <div class="w-100 ml-3">{{currentLanguage | uppercase}}</div>
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <a class="d-block pl-2 py-1" (click)="setCurrentLanguage(lang,true)" *ngFor="let lang of languages">
          {{lang | uppercase}}
        </a>
      </ng-template>
    </p-accordionTab>
  </p-accordion>
</div>

<div class="mobile-language d-flex" *ngIf="screenWidth<1025 && !user">
  <span>{{"GENERAL.LANGUAGE" | translate }}:</span> &nbsp;
  <a class="d-block" [ngClass]="{'text-white' : currentLanguage===lang }" (click)="setCurrentLanguage(lang,true)"
    *ngFor="let lang of filters">
    {{lang | uppercase}}
  </a>
</div>
